<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div>
    <!-- CADASTRO-->
    <div class="row">
      <div class="col-md-12">
        <div class="card card-primary">
          <div class="card-header">
            <h3 class="card-title" style="color: white">Nova campanha</h3>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputFile">Nome de referência</label>
                  <input class="form-control" v-model="formData.nome_campanha" />

                  <span style="color: red" v-for="error in v$.nome_campanha.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputFile">Título da campanha</label>
                  <input class="form-control" v-model="formData.titulo_campanha" />

                  <span style="color: red" v-for="error in v$.titulo_campanha.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputFile">Link</label>
                  <input class="form-control" v-model="formData.conteudo_link" />

                  <span style="color: red" v-for="error in v$.conteudo_link.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputFile">Imagem</label>
                  <input class="form-control" type="file" @change="onChange" />

                  <span style="color: red" v-for="error in v$.upload_files.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>
              <div class="col-sm-12" v-if="formData.upload_files">
                <div class="form-group">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Pré-visualizar</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12" v-if="preview && url_arquivo">
                <div class="form-group">
                  <img
                    style="cursor: pointer; max-height: 235px; max-width: 325px"
                    :src="url_arquivo"
                    data-toggle="modal"
                    data-target="#exibir-imagem-modal"
                  />
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label for="nome">Lista</label>
                <select class="custom-select rounded-0" v-model="formData.lista_id" style="text-transform: uppercase">
                  <option value=""></option>
                  <option v-for="lista in listas" :key="lista.id" :value="lista.id">{{ lista.nome }}</option>
                </select>

                <span style="color: red" v-for="error in v$.lista_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>

          <!--
          <Editor class="editor_prime" style="background-color: white" editorStyle="height: 200px;" v-model="conteudo" id="conteudo_notificacao" />
          -->

          <div class="card-footer">
            <button type="submit" class="btn btn-primary" @click="sendFileS3()">Cadastrar</button>
            <a type="submit" href="/admin/newsletter" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- EXIBIR IMAGEM MODAL -->
  <div class="modal fade" id="exibir-imagem-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <div class="form-group">
              <img style="width: 100%" :src="url_arquivo" data-toggle="modal" data-target="#exibir-imagem-modal" />
            </div>

            <button type="submit" class="btn btn-primary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";
import InputMask from "primevue/inputmask";

import useVueLidate from "@vuelidate/core";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  props: ["listas"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading, Editor, InputMask },

  data() {
    return {
      isLoading: false,
      registro_selecionado: "",
      filtro: "",
      paginas: [],
      registros: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome_contato: "",
      max_page: 0,
      editar_registro: false,
      cadastrar_registro: false,
      conteudo: "",
      preview: true,
      url_arquivo: "",
    };
  },

  setup() {
    const formData = reactive({
      nome_campanha: "",
      titulo_campanha: "OPORTUNIDADES DA PRÓXIMA SEMANA",
      conteudo_link: "rochaleiloes.com.br",
      upload_files: "",
      lista_id: 2,
    });

    const rules = computed(() => {
      let local_rules = {
        nome_campanha: { required },
        titulo_campanha: { required },
        conteudo_link: { required },
        upload_files: { required },
        lista_id: { required },
      };

      return local_rules;
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log(this.registros);

    //this.conteudo = '<div><a href="https://rochaleiloes.com.br/lote/17549/imovel-no-jardim-botanico"><img src="https://s3.amazonaws.com/static.rochaleiloes.com.br/rochaleiloes/storage/imagens/upload_img_w2PQ4o6xTjvULxLqAdMbpgyMJvciMMPKo8vTK9I4DFzQHvqgWUG3StEWdQzp.jpeg" alt="" width="1345" height="1456" /></a></div>';
  },

  methods: {
    onChange(e) {
      this.formData.upload_files = e.target.files[0];
      this.url_arquivo = URL.createObjectURL(this.formData.upload_files);
    },

    async sendFileS3() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        return new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("id", "1");
          formData.append("path", "rochaleiloes2/newsletter/");
          formData.append("file", this.formData.upload_files);

          axios
            .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
            .then((response) => {
              console.log("ENVIANDO PARA O BANCO\n");

              this.uploadFD(response.data.key);
            })
            .catch((error) => {
              console.log(error);

              this.isLoading = false;
              this.showErrorMessageWithButton("Ops..", error.response.data.error);
              console.log(error);
              reject();
            });
        });
      } else {
        console.log(this.v$);
      }
    },

    uploadFD(file) {
      this.isLoading = true;

      let fileName = file.split("/");

      let data = {
        link: this.formData.conteudo_link,
        campanha_ref: this.formData.nome_campanha,
        campanha_titulo: this.formData.titulo_campanha,
        lista_id: this.formData.lista_id,
        url_imagem: file,
      };

      console.log("Cadastrando");
      console.log(data);

      axios
        .post(`/admin/newsletter/store`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Campanha cadastrada", "/admin/newsletter");
        })
        .catch((error) => {
          console.log(error);

          this.isLoading = false;

          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDateToSave(date) {
      return moment(date, "DD/MM/yyyy HH:mm:ss").format("yyyy-MM-DD HH:mm:ss");
    },

    buscarRegistros() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      let url = null;

      if (this.objeto == "Lance") {
        url = "/admin/registros_deletados/lances/search";
      } else if (this.objeto == "Lote") {
        url = "/admin/registros_deletados/lotes/search";
      } else if (this.objeto == "Leilao") {
        url = "/admin/registros_deletados/leiloes/search";
      } else if (this.objeto == "Cadastro") {
        url = "/admin/registros_deletados/cadastros/search";
      }

      if (!url) {
        this.showErrorMessageWithButton("Ops...", "Selecione o tipo de objeto");
      } else {
        console.log("URL =");
        console.log(url);

        axios
          .post(url, data)
          .then((response) => {
            this.registros = response.data.registros;
            this.total = response.data.total;

            this.pagination(response.data);
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
    },

    limparFiltros() {
      this.objeto = null;
      this.registros = [];
    },

    deletar(registro) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: registro.id,
            };

            axios
              .post(`/admin/registro/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessage("registro deletado!");
                this.buscarRegistros();
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarRegistros();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.current-page {
  background-color: #428bca !important;
  color: white;
}

.modal-content {
  width: 1500px;
  margin-left: -430px;
}

@media screen and (max-width: 1600px) {
  .modal-content {
    width: 1350px;
    margin-left: -400px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1350px) {
  .modal-content {
    width: 1250px;
    margin-left: -350px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -280px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 1000px;
    margin-left: -240px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
    min-width: 400px;
  }
}
</style>
